// extracted by css-extract-rspack-plugin
export default {"root":"root-AkpP8V","title":"title-VRqdpA text-lg-semibold","description":"description-rFqedJ text-sm"};